<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('manage')}}</h6>
                                <h1 class="header-title">{{$t('Complaints DB')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'CdbEditModal', model:{language}})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <!-- Search -->
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                                <span class="fe fe-search text-muted" v-else></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto" v-if="false">
                                        <b-button-group>
                                            <button
                                                class="btn btn-white"
                                                @click="specialtyQuery=[]"
                                                v-if="specialtyQuery.length>0"
                                            >
                                                <span class="fe fe-x"></span>
                                            </button>
                                            <b-dropdown variant="white" right :text="$t('Specialty')">
                                                <div
                                                    v-for="(specialty, index ) in specialties"
                                                    :key="index"
                                                    class="dropdown-item pl-3"
                                                >
                                                    <b-form-checkbox
                                                        v-model="specialtyQuery"
                                                        :value="specialty._id"
                                                    >{{specialty.label }}</b-form-checkbox>
                                                </div>
                                            </b-dropdown>
                                        </b-button-group>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 pl-4 pr-4" v-if="breadcrumbs.length>0">
                                <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                            </div>
                            <simple-table
                                :data="cdb"
                                :loading="cdbLoading"
                                :edit="edit"
                                :deleteItem="deleteItem"
                                :hideDeleteButton="true"
                                :columns="columns"
                                :sort="sort"
                            ></simple-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <cdb-modal id="CdbEditModal" :data="model"></cdb-modal>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import CdbModal from './CdbModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import { cdbMixins } from '@/mixins/cdb.js'
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    props: ['icd'],
    mixins: [modalMixins, cdbMixins],
    components: {
        SimpleTable,
        CdbModal
    },
    data() {
        return {
            query: null,
            specialtyQuery: [],
            language: 'russian',
            model: {
                icdCode: this.icd
            },
            columns: [
                {
                    label: 'Code',
                    name: 'code',
                    width: '1%',
                },
                // {
                //     name: 'rank',
                //     label: 'Rank',
                //     width: '1%',
                //     field(item) {
                //         return item.rank || 0;
                //     }
                // },
                {
                    label: 'Name',
                    name: 'label',

                    field: (item) => {
                        if (item.label.length > 100) {
                            return item.label.substring(0, 100) + '...';
                        } else {
                            return item.label
                        }
                    },
                    subtitle: (item) => {
                        let data = [];
                        item.icd.forEach(element => {
                            data.push(element.label);
                        });;
                        let string = data.join(', ');

                        if (string.length > 100) {
                            return string.substring(0, 100) + '...';
                        } else {
                            return string
                        }
                    },
                },


            ],
            sort: '',
            breadcrumbs: [],
        }
    },
    watch: {

    },
    computed: {
        ...mapGetters('specialty', {
            findSpecialtyInStore: 'find',
        }),

        specialties() {
            return this.findSpecialtyInStore().data;
        },
    },

    created() {
        this.queryItems();
        this.fetchSpecialties();

    },

    methods: {
        ...mapActions('cdb', ['find', 'create', 'patch', 'remove', 'get']),
        ...mapActions('specialty', { fetchSpecialties: 'find' }),


        save() {
            let promise, successMessage;
            if (this.model._id) {
                promise = this.patch([this.model._id, this.model]);
                successMessage = this.$t('Item has been saved');
            } else {
                promise = this.create(this.model);
                successMessage = this.$t('Item has been created');
            }

            promise.then(result => {

                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });

            });

        },
        edit(item) {
            this.openModal({ id: 'CdbEditModal', model: item });
        },
        deleteItem(item) {
            this.remove(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            })
        },



    }
}
</script>

